import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { LanguageService } from 'src/app/services/language.service';
import { RouterUrls } from '../router-urls';
import { Constants } from '../../app.constants';

@Component({
  selector: 'app-brand-card',
  templateUrl: './brand-card.component.html',
  styleUrls: ['./brand-card.component.scss']
})
export class BrandCardComponent implements OnInit, AfterViewInit {

  @Input() logo: string;
  @Input() picture: string;
  @Input() slug: string;

  isCardHovered = false;
  isTablet: boolean;
  brandUrl: string;
  isVisible = false; // Tracks if the card is visible in the viewport for lazy loading

  constructor(
    private breakpointObserver: BreakpointObserver,
    private languageService: LanguageService
  ) {
  }

  ngOnInit(): void {
    this.brandUrl = `${Constants.APP_URL + this.languageService.getLanguage()}/${RouterUrls.Brands}/${this.slug}`;

    this.breakpointObserver
      .observe(['(max-width: 991px)'])
      .subscribe((state: BreakpointState) => {
        this.isTablet = state.matches;
      });
  }

  /**
   * After the view is initialized, start observing visibility to trigger
   * lazy loading of background image when the element enters the viewport.
   */
  ngAfterViewInit(): void {
    this.observeVisibility();
  }

  /**
   * Uses the IntersectionObserver API to detect when the brand card enters
   * the viewport, and triggers the background image loading.
   */
  observeVisibility(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          observer.disconnect(); // Stop observing once it's visible
        }
      });
    });

    const brandCardElement = document.querySelector(`#brand-card-${ this.slug }`) as Element;
    if (brandCardElement) {
      observer.observe(brandCardElement);
    }
  }

  /**
   * Returns a background style with a gradient overlay and the brand's picture.
   * The image is only loaded when the card becomes visible in the viewport.
   */
  getBackgroundImageWithGradient(): {[key: string]: string} {
    if (this.isVisible) {
      return {
        backgroundImage: `linear-gradient(0deg, rgba(15,70,84,1) 0%, rgba(15,70,84,0) 45%, rgba(15,70,84,0) 100%), url(${ this.picture })`
      };
    }
    return {};  // Return an empty object if not visible to prevent loading
  }
}
